import React from "react";
import { getNextQty, getPrevQty, MAX_CART_QTY } from "../utils/cartQuantity";

const CartQuantityControl = ({
  qty,
  minQty = 1,
  stock = 0,
  step,
  maxQuantity,
  purchaseType = "piece",
  product = {},
  onChange,
  className = "cart-qty-control",
  buttonClassName = "cart-qty-btn",
  valueClassName = "cart-qty-value",
}) => {
  const currentQty = Number(qty) || Number(minQty) || 1;
  const stockQty = Number(stock) || 0;
  const stockMaxQty = stockQty > 0 ? Math.min(stockQty, MAX_CART_QTY) : MAX_CART_QTY;
  const maxQty = Number(maxQuantity) > 0
    ? Math.min(Number(maxQuantity), stockMaxQty)
    : stockMaxQty;

  const stepQty = Number(step) || 0;
  const effectiveStep = stepQty;
  const minimumQty = Number(minQty) || 1;

  const handleMinus = () => {
    const nextQty = effectiveStep
      ? Math.max(currentQty - effectiveStep, minimumQty)
      : getPrevQty(currentQty, minimumQty, purchaseType, product);
    if (nextQty !== currentQty) onChange(nextQty, "minus");
  };

  const handlePlus = () => {
    const nextQty = effectiveStep
      ? Math.min(currentQty + effectiveStep, maxQty)
      : getNextQty(currentQty, stockQty, MAX_CART_QTY, purchaseType, product);
    if (nextQty !== currentQty) onChange(nextQty, "add");
  };

  return (
    <div className={className}>
      <button
        type="button"
        className={buttonClassName}
        onClick={handleMinus}
        disabled={currentQty <= minimumQty}
      >
        -
      </button>
      <span className={valueClassName}>{currentQty}</span>
      <button
        type="button"
        className={buttonClassName}
        onClick={handlePlus}
        disabled={currentQty >= maxQty}
      >
        +
      </button>
    </div>
  );
};

export default CartQuantityControl;
